module.exports = __webpack_public_path__ + "img/tianjin.b1087a49.jpg";